import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent }   from './dashboard/dashboard.component';
import { HomeComponent }   from './home/home.component';
import { LoginComponent }   from './login/login.component';
import { AuthGuard } from './extras/auth.guard';
import { GroupWidgetsComponent } from './group-widgets/group-widgets.component'

import { ShareWidgetsComponent } from './shared/components/share-widgets/share-widgets.component'
import {SotableWidgetComponent} from './shared/components/sotable-widget/sotable-widget.component'
import { NewAppWidgetComponent } from './shared/components/new-app-widget/new-app-widget.component'

import { ReportSettingsComponent } from './components/report-settings/report-settings.component';
import { InspectionReportSettingComponent } from './components/inspection-report-setting/inspection-report-setting.component';
import { BillingReportSettingComponent } from './components/billing-report-setting/billing-report-setting.component';
import { AddCannedReplyComponent } from './components/canned-replies/add-canned-reply/add-canned-reply.component';
import { EditCannedReplyComponent } from './components/canned-replies/edit-canned-reply/edit-canned-reply.component';
import { DiagramComponent } from './components/diagram/diagram.component';
import { ChatMainComponent } from './modules/chat/chat-main/chat-main.component';
import { ChatAuthComponent } from './modules/chat/chat-auth/chat-auth.component';
import { ChatAuthGuard } from './modules/chat/guards/chat-auth.guard';
import { PromptsComponent } from './modules/chat/prompts/prompts.component';
const routes: Routes = [
	{ path: 'login', component: LoginComponent },
  	{path: '', canActivate: [AuthGuard], children: [
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
      { path: 'dashboard', component: DashboardComponent },
      { path:'groupwidget/:groupId', component:GroupWidgetsComponent },
      { path:'share-widgets', component:ShareWidgetsComponent },
      { path:'sort-widgets', component:SotableWidgetComponent },
      { path:'new-app-widget', component:NewAppWidgetComponent },
      { path:'report-settings', component:ReportSettingsComponent },
      { path:'findings-report-settings', component:InspectionReportSettingComponent },
      { path:'billing-report-settings', component:BillingReportSettingComponent },
      { path:'canned-replies', component:AddCannedReplyComponent },
      { path:'edit-canned-reply/:id', component:EditCannedReplyComponent },
      { path:'rodents', component:DiagramComponent },
      { path:'rodents/:id', component:DiagramComponent },
      { path: 'clients', loadChildren: './modules/client/client.module#ClientModule' },
      { path: 'agencies', loadChildren: './modules/agency/agency.module#AgencyModule' },
      { path: 'codes-list', loadChildren: './modules/codes/codes.module#CodesModule' },
      { path: 'import-users', loadChildren: './modules/user-import/user-import.module#UserImportModule' },
      { path: 'import-zipcodes', loadChildren: './modules/zip-import/zip-import.module#ZipImportModule' },
      { path: 'revenue-types', loadChildren: './modules/revenue-types/revenue-types.module#RevenueTypesModule' },
      { path: 'document-library', loadChildren: './modules/document-library/document-library.module#DocumentLibraryModule' },
      { path: 'calendar-settings', loadChildren: './modules/calendar-settings/calendar-settings.module#CalendarSettingsModule' },
      { path: 'findings-settings', loadChildren: './modules/findings-settings/findings-settings.module#FindingsSettingsModule' },
      { path: 'milo', children: [
        { path: 'auth', component: ChatAuthComponent },
        { path: 'prompts/index', component: PromptsComponent, canActivate: [ChatAuthGuard] },
        { path: ':id', component: ChatMainComponent, canActivate: [ChatAuthGuard] },
        { path: '', component: ChatMainComponent, canActivate: [ChatAuthGuard] }
      ]}
    ]}
];

@NgModule({
  exports: [ RouterModule ],
  imports: [ RouterModule.forRoot(routes) ],
})
export class AppRoutingModule {}
